import { NavTabs } from "src/components/ui/NavTabs";

import { useAppState } from "src/state";

export function AgencyOperationsAdminBookingTabs({
    overlay = false
}: React.PropsWithChildren<{
    overlay?: boolean
}>): React.ReactElement {

    const { currentItemId } = useAppState(state=>state.bookings)

    return ( 
        <NavTabs
            overlay={overlay}
            parentId={currentItemId}
            urlRoot='/bookings'
            tabs={{
                details: {
                    label: 'Booking Overview',
                    icon: 'home',
                    route: ''
                },
                guidelines: {
                    label: 'Booking Guidelines',
                    icon: 'guideline',
                    route: 'guidelines'
                }
            }}
        />
    )

}